import { AppConsts } from '@shared/AppConsts';
import { ActivatedRoute, NavigationExtras, Params } from '@angular/router';

export class UrlHelper {
    /**
     * The URL requested, before initial routing.
     */
    static readonly initialUrl = location.href;

    static getQueryParameters(): any {
        return document.location.search
            .replace(/(^\?)/, '')
            .split('&')
            .map(
                function (n) {
                    return (n = n.split('=')), (this[n[0]] = n[1]), this;
                }.bind({}),
            )[0];
    }

    static getUrlByPosition(position: number): string {
        const href = document.location.href.replace(AppConsts.appBaseUrl, '');
        return href.split('/')?.at(position) as string;
    }
}

export const appendQueryParams = (queryParams: Params, route: ActivatedRoute): NavigationExtras => {
    return {
        relativeTo: route,
        queryParams,
        queryParamsHandling: 'merge',
        preserveFragment: true,
    };
};
